<template>
  <div :class='type == "scan" ? "":"s_bf p-24"' style="padding-top: 0;">
    <a-tabs>
      <a-tab-pane key="1" tab="扫码人信息">
        <a-descriptions class="m-t-20" bordered :column='3' layout="vertical">
          <a-descriptions-item label="会员ID">{{user.member_id}}</a-descriptions-item>
          <a-descriptions-item label="扫码者昵称">{{user.member_name}}</a-descriptions-item>
          <a-descriptions-item label="姓名">-</a-descriptions-item>
          <a-descriptions-item label="性别">{{user.sex == 1 ? '男':user.sex == 0?'未知':'女'}}</a-descriptions-item>
          <a-descriptions-item label="手机">{{user.phone || '-'}}</a-descriptions-item>
          <a-descriptions-item label="关注时间">-</a-descriptions-item>
        </a-descriptions>
      </a-tab-pane>
      <a-tab-pane key="2" tab="码信息">
        <a-descriptions class="m-t-20" bordered :column='3' layout="vertical">
          <!-- <a-descriptions-item label="码段">{{code.code_sn}}</a-descriptions-item> -->
          <a-descriptions-item label="批次">{{code.batch_sn}}</a-descriptions-item>
          <a-descriptions-item label="流水号">{{code.code_sn}}</a-descriptions-item>
          <a-descriptions-item label="码ID">{{code.product_code || '-'}}</a-descriptions-item>
          <a-descriptions-item label="防伪码">{{code.fwcode_sn || '-'}}</a-descriptions-item>
          <a-descriptions-item label="关联流水号">{{code.sn}}</a-descriptions-item>
          <a-descriptions-item label="商品ID">{{code.product_id || '-'}}</a-descriptions-item>
          <a-descriptions-item label="商品名称">{{code.product_name || '-'}}</a-descriptions-item>
          <!-- <a-descriptions-item label="商品编码"></a-descriptions-item>
          <a-descriptions-item label="商品规格"></a-descriptions-item>
          <a-descriptions-item label="经销商编号"></a-descriptions-item>
          <a-descriptions-item label="经销商名称"></a-descriptions-item>
          <a-descriptions-item label="门店编号"></a-descriptions-item>
          <a-descriptions-item label="门店名称"></a-descriptions-item> -->
          <a-descriptions-item label="扫码地区">{{code.address || '-'}}</a-descriptions-item>
          <a-descriptions-item label="详细地址">{{code.area || '-'}}</a-descriptions-item>
          <a-descriptions-item label="经纬度">
            <span v-if='code.latitude'>{{code.latitude}}，{{code.longitude}}</span>
            <span v-else>-</span>
          </a-descriptions-item>
            <a-descriptions-item label="扫码门店/经销商">
                {{code.belong_channel_code}}
                {{code.belong_channel_name}}
          </a-descriptions-item>
        </a-descriptions>
      </a-tab-pane>
      <a-tab-pane key="3" tab="活动信息">
        <a-descriptions class="m-t-20" bordered :column='3' layout="vertical">
          <a-descriptions-item label="活动ID">{{activity.activity_id || '-'}}</a-descriptions-item>
          <a-descriptions-item label="活动名称">{{activity.activity_name || '-'}}</a-descriptions-item>
          <a-descriptions-item label="抽奖时间">{{activity.prize_time || '-'}}</a-descriptions-item>
          <a-descriptions-item label="奖项名称">{{activity.award_name || '-'}}</a-descriptions-item>
          <a-descriptions-item label="领奖来源">扫码</a-descriptions-item>
          <a-descriptions-item label="奖品发放策略">{{activity.ploy_name || '-'}}</a-descriptions-item>
        </a-descriptions>
        <p class="m-t-20 m-b-20 fz-16 ">奖项内容：</p>
        <a-table :pagination='false' :loading='listLoading' bordered rowKey='award_content' :columns='columns' :data-source='activity.award_list'>
            <template v-slot:action="{ record }">
            <a href="javascript:;" @click="couponDetail(record)" v-if="record.award_type=='coupon_award'">优惠券明细</a>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
      <a-modal  :keyboard="false" title="优惠卷明细" centered v-model:visible="showCoupon" :width='1300' :footer="null" destroyOnClose>
          <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
          <a-form-item label="券名称" name='name'>
            <a-input v-model:value="search.name" style="width:270px" placeholder="请输入卡券名称" />
          </a-form-item>
          <a-form-item label="券类型" name='coupon_type'>
            <a-select v-model:value="search.coupon_type" :style="{width:'140px'}" placeholder="全部">
              <a-select-option value="">全部类型</a-select-option>
              <a-select-option :value="2">现金券</a-select-option>
              <a-select-option :value="3">代金券</a-select-option>
              <a-select-option :value="1">折扣券</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType='submit'>搜索</a-button>
          </a-form-item>
        </a-form>
        <a-table :pagination='false' :loading='listLoading' bordered  :columns='couponColumns' :data-source='couponList'>
        </a-table>
         <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper
          :current="search.page" :page-size="search.limit" :total="search.total" @change="pageCurrentChange"
          @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-modal>
  </div>
</template>

<script>
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { scan_logs_detail } from '@/api/qrcode'
  import { getAwardMore,getMemberCoupon } from "@/api/qrcodeActivitys";
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  export default {
    props: {
      type: String,
      id:Number || String
    },
    setup(props) {
      const state = reactive({
        listLoading:true,
        activity:{},
        code:{},
        user:{},
        data:[],
        type:'scan',
        id:0
      })
      let columns = [
        {
          title: "奖项内容",
          dataIndex: "award_name",
          key: "award_name",
        },
        {
          title: "发放状态",
          dataIndex: "award_status_title",
          key: "award_status_title",
        },
      {
          title: "具体信息",
          dataIndex: "action",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $route = inject('$route');
      const $router = inject('$router');
      const _lodash = inject("_lodash");
      const couponColumns=[
        {
          title: "卡券ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "优惠",
          key: "amount_text",
          dataIndex:"amount_text",
          align:"center",
          slots: { customRender: "amount_text" },
        },
        {
          title: "券类型",
          dataIndex: "coupon_type_text",
          key: "coupon_type_text",
        },
        {
          title: "有效期",
          key: "valid_period_time",
          dataIndex:'valid_period_time'
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
          customRender: ({ record }) => {
            return record.remark ? record.remark : '-'
          }
        }
      ]
      const search = ref({
          page: 1,
          limit: 5,
          keyword: "",
          total:0,
          coupon_type:'',
          name:"",
          search_type:'order_no'
      });
      const couponList=ref([])
      const showCoupon=ref(false)
      const couponDetail=async (data)=>{
        search.value.keyword='scan_award_'+state.activity.scan_award_id
        let result=await getMemberCoupon(search.value).then(res=>res.data).catch(error=>error)
        showCoupon.value=true
        couponList.value=result.data.data
        search.value.total=result.data.total
      }

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        couponDetail(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        couponDetail(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        couponDetail(search.value);
      };
      const getMore = async() =>{
        const hide = message.loading('正在加载中...', 0);
        let res
        if(state.type == 'scan'){
          res = await scan_logs_detail(state.id).then((res) => res.data);
        }else{
          res = await getAwardMore(state.id).then((res) => res.data);
        }
        state.listLoading = false
        if (iscode(res)) {
          state.activity = res.data.activity
          state.code = res.data.code
          state.user = res.data.user
          if(res.data.activity.is_point == 1){
            state.data.push(res.data.activity.point_info)
          }
          if(res.data.activity.is_gift == 1){
            state.data.push(res.data.activity.gift_info)
          }
          if(res.data.activity.is_bonus == 1){
            state.data.push(res.data.activity.bonus_info)
          }
        }else{
          message.error(res.msg);
        }
        setTimeout(hide);
      }
      onMounted(() => {
        state.type = props.type
        state.id = props.id
        getMore()
      });
      return {
        ...toRefs(state),
        columns,
        couponDetail,
        showCoupon,
        couponColumns,
        pageCurrentChange,
        pageSearchChange,
        pageSizeChange,
        couponList,
        search
      }
    }
  }
</script>